@if (itemsWithJsonData.length) {
    <app-table
        [items]="itemsWithJsonData"
        [columns]="columns"
        translatePrefix="form.msse."
        [hideCheckboxes]="true"
        [resource]="resource"
        (detailCallback)="detail($event)"
        (deleteCallbackWithEvent)="delete($event)"
    >
        <ng-template pTemplate="printHeader"></ng-template>
        <ng-template pTemplate="print" let-item="item">
            <app-button
                [text]="true"
                styleClass="p-button-set-icon-size"
                icon="pi-print"
                (clickEvent)="print(item)"
            ></app-button>
        </ng-template>

        <ng-template pTemplate="copyHeader"></ng-template>
        <ng-template pTemplate="copy" let-item="item">
            <app-button
                [text]="true"
                styleClass="p-button-set-icon-size"
                icon="pi-copy"
                (clickEvent)="copy(item)"
            ></app-button>
        </ng-template>

        <ng-template pTemplate="restlessness" let-item="item">
            {{ (item.data.restlessness ? 'yes' : 'no') | translate }}
        </ng-template>

        <ng-template pTemplate="shouts" let-item="item">
            {{ (item.data.shouts ? 'yes' : 'no') | translate }}
        </ng-template>

        <ng-template pTemplate="pain" let-item="item">
            {{ (item.data.pain ? 'yes' : 'no') | translate }}
        </ng-template>

        <ng-template pTemplate="decubitus" let-item="item">
            {{ (item.data.decubitus ? 'yes' : 'no') | translate }}
        </ng-template>

        <ng-template pTemplate="malnutrition" let-item="item">
            {{ (item.data.malnutrition ? 'yes' : 'no') | translate }}
        </ng-template>

        <ng-template pTemplate="eatingDisorders" let-item="item">
            {{ (item.data.eatingDisorders ? 'yes' : 'no') | translate }}
        </ng-template>

        <ng-template pTemplate="conflictBehavior" let-item="item">
            {{ (item.data.conflictBehavior ? 'yes' : 'no') | translate }}
        </ng-template>

        <ng-template pTemplate="unstableStateOfHealth" let-item="item">
            {{ (item.data.unstableStateOfHealth ? 'yes' : 'no') | translate }}
        </ng-template>

        <ng-template pTemplate="sufferingAccordingToMedic" let-item="item">
            {{ (item.data.sufferingAccordingToMedic ? 'yes' : 'no') | translate }}
        </ng-template>

        <ng-template pTemplate="sufferingAccordingToCaregiver" let-item="item">
            {{ (item.data.sufferingAccordingToCaregiver ? 'yes' : 'no') | translate }}
        </ng-template>

    </app-table>
}
